import React, { Component } from 'react';
import Parse from 'parse';
import styled from 'styled-components'
import cssVar from '../../styles/variables'

import { inject, observer } from 'mobx-react'
import config from 'react-global-configuration';
import { withColor, PrimaryButton, Text, FullWidthWrapper, Heading2, SlimSection, GridRow, Heading4, TextField } from '../marketing/MarketingStyles';

import { trackEvent } from "../../utils/eventTracking"

@inject('utilStore')
@observer
class RequestPhoneCallSection extends Component {

  constructor(props) {
    super(props)

    this.state = {
      state: 0,
    }
  }

  sendRequest = (e) => {
    e.preventDefault();
    const data = e.target

    this.setState({ state: 1 })
    trackEvent( 'Arrange Callback - Detail Page', 'Meeting', 'Click Button' )
    Parse.Cloud.run( 'requestMoreInformation', {
      name: data.name.value,
      phone: data.phone.value,
      companyName: data.companyName.value,
      mail: undefined,
      type: 1,
    }).then(() => {
      this.setState({ state: 2 })
    }).catch(e => this.setState({ state: 0 }))
  }

  render() {

    const { partners } = this.props.utilStore.util
    const { state } = this.state

    return (
      <SlimSection>
        <GridRow desktop="1fr 1fr" tablet="1fr">
          <div>
            <Heading4>Kontakt aufnehmen</Heading4>
            <Heading2>Jetzt Rückruf anfordern</Heading2>
          </div>
        </GridRow>
        <form onSubmit={ this.sendRequest }>
          <GridRow
            desktop="1fr 1fr"
            tablet="1fr" tabletRowGap
          >
            <TextField name="name" placeholder="Name" required />
            <TextField name="companyName" placeholder="Firmenname" required />
            <TextField name="phone" placeholder="Telefonnummer" required />
          </GridRow>
          <div style={{ textAlign: 'right' }}>
            <PrimaryButton
              value={ state === 0 ? 'Jetzt senden' : state === 1 ? 'Sende Anfrage ...' : 'Anfrage gesendet'}
              disabled={ state !== 0 }
              style={{ marginTop: 30, display: 'inline-block'}}
              autoWidth
            />
            {state === 2 && <GreyText>Danke für Ihre Anfrage!</GreyText>}
          </div>
        </form>
      </SlimSection>
    )
  }
}

export default RequestPhoneCallSection


const GreyText = styled(withColor(Text, cssVar.colors.grey)) `
  max-width: 100%;
`



// WEBPACK FOOTER //
// /src/components/marketing/RequestPhoneCallSection.js